// extracted by mini-css-extract-plugin
export var fadeIn = "_lp-1";
export var modalContent = "_lp-3";
export var overlay = "_lp-0";
export var popoverContent = "_lp-2";
export var results = "_lp-5";
export var searchInputWrapper = "_lp-4";